import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useTeamColors } from 'hooks';
import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from 'firebase.js';
import { backgroundImages } from 'assets/img';
import {
  ChoiceTitle,
  ErrorMessage,
  Loading,
  TopNav,
  // AuthContainer,
  UpcomingGamesHeader,
  DashboardUpcomingGames,
} from 'components';

import {
  BodyContainer,
  MainContainer,
  StyledHeader,
  StyledFooter,
  BackgroundImg,
} from 'components/App/style';

export const UpcomingGames = () => {
  const analytics = getAnalyticsInstance();
  const {
    loading: isConfigLoading,
    error: isConfigError,
    data: configData,
  } = useSelector((state) => state.configuration);
  const { mainColorRgba } = useTeamColors();

  // Check if top nav is enabled
  const isTopNavEnabled = useSelector((state) => {
    const val = state.configuration?.data?.top_nav_enabled;
    return val === 1 || val === '1';
  });
  const {
    data: leagues,
    error: isLeaguesError,
    loading: leaguesLoading,
  } = useSelector((state) => state.leagues);

  const [searchParams] = useSearchParams();
  const selectedLeague = searchParams.get('league');

  if (isConfigLoading || leaguesLoading) {
    return <Loading />;
  }

  if (isConfigError || isLeaguesError) {
    logEvent(analytics, 'select_content', {
      content_type: 'error',
      content_id: `Unable to load configuration or league for ${window.location.href}`,
    });

    return (
      <ErrorMessage title=" Oops... Service currently unavailable. We are working on it. Please try again later." />
    );
  }

  return (
    <BodyContainer
      $backgroundColorEnd={
        (configData?.display_one_team === '1' ||
          configData?.display_one_team === 1) &&
        Boolean(configData?.style_main_color)
          ? mainColorRgba(0)
          : null
      }
      $backgroundColorStart={
        (configData?.display_one_team === '1' ||
          configData?.display_one_team === 1) &&
        Boolean(configData?.style_main_color)
          ? mainColorRgba(0.5)
          : null
      }
      $hasTopNav={isTopNavEnabled}
    >
      {!selectedLeague ? (
        <BackgroundImg
          $imgUrl={backgroundImages['sport-background']}
          style={{
            background: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.85) 100%), url(${backgroundImages['sport-background']})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        />
      ) : null}
      {selectedLeague ? (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            zIndex: -1,
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.85) 100%)',
            pointerEvents: 'none',
          }}
        />
      ) : null}
      {isTopNavEnabled ? <TopNav /> : null}
      <StyledHeader>
        {/* <AuthContainer /> */}
        <UpcomingGamesHeader leagues={leagues} />
      </StyledHeader>
      <MainContainer>
        {!selectedLeague ? <ChoiceTitle title="Select league" /> : null}
        <DashboardUpcomingGames />
      </MainContainer>
      <StyledFooter />
    </BodyContainer>
  );
};
